<template>
  <div class="w-full">
    <div class=" pt-4 pr-4 pl-4 pb-10 relative rounded-2xl border border-gray-500 shadow-sm bg-white">

      <div @click="cartModal()"
        class="absolute top-0 right-0 cursor-pointer flex items-center gap-2 rounded-full px-2 py-2 w-max shadow-[0px_0px_10px_0px_#00000026;] -translate-x-6 -translate-y-7 bg-white">
        <div class="flex items-center gap-2 rounded-full px-3 py-1 w-max bg-cyan-400">
          <img src="../../assets/images/cart-check-white.png" alt="Cart Icon" class="w-7 h-7">
          <span class="text-xl font-roboto font-bold text-white">5</span>
        </div>
        <span class="font-roboto font-bold text-2xl text-black-100">$9999.99</span>
      </div>

      <customSlider>
        <Slide v-for="(plan, index) in plans" :key="index">
          <protectionPlanCard :plan="plan">
            <template #action>
              <a href="#"
                class="py-1.5 px-3 text-base rounded-full border-[1px] no-underline !border-purple-100 text-purple-100 hover:bg-purple-100 hover:text-white"
                data-bs-toggle="modal" data-bs-target="#protectionPlanDetailModal">
                View Details
              </a>
            </template>
          </protectionPlanCard>
        </Slide>
      </customSlider>

      <div @click="nrgModal()"
        class="absolute bottom-0 right-0 -translate-x-5 translate-y-5 flex mobile:justify-center tablet:justify-end w-full">
        <button
          class="px-3 py-1.5 mt-4 flex justify-end items-center gap-1 text-base rounded-full bg-[#FC819E] hover:!shadow-md">
          <span class="text-white">Go to NRG Protects to Enroll</span>
          <img src="../../assets/images/arrow-icon.png" class="w-7 h-7 object-contain" alt="icon">
        </button>
      </div>
      
    </div>
  </div>

  <!-- Protection Plan Detail Modal -->
  <div class="modal fade" id="protectionPlanDetailModal" tabindex="-1" aria-labelledby="protectionPlanDetailModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered !w-[500px] !absolute !right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative rounded-lg overflow-hidden h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
              <div class="flex flex-col justify-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <div class="flex justify-start items-center gap-1">
                  <div class="w-1.5 h-1.5 rounded-full bg-purple-100"></div>
                  <div class="w-6 h-1.5 rounded-full bg-purple-100"></div>
                  <p class=" text-lg font-bold font-roboto pl-2 m-0 text-fuchsia-700">New Plan</p>
                </div>
                <h4 class="text-xl m-0 text-black-100">Cooling Repair and Maintenance PLUS Plan</h4>
              </div>
            </div>
          </div>
          <div class="max-h-[90vh] overflow-y-auto customScrollbar">
            <protectionPlanDetailCard />
            <button
              class="group px-3 py-1.5 mt-4 flex justify-center items-center mx-auto gap-1 text-base rounded-full border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white">
              <img src="../../assets/images/cart-check.png" class="w-7 h-7 object-contain group-hover:hidden"
                alt="icon">
              <img src="../../assets/images/cart-check-white.png"
                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon">
              Select this plan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cart Modal -->
  <div class="modal fade" id="cartModal" ref="cartModal" tabindex="-1" aria-labelledby="cartModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered !w-[500px] !absolute !right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative rounded-lg overflow-hidden h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
              <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <img src="../../assets/images/cart-check.png" alt="Background" class="w-10 h-10 object-cover">
                <h4 class="text-xl m-0 font-roboto font-bold text-black-100">Cart</h4>
              </div>
            </div>
          </div>
          <div class="max-h-[80vh] overflow-y-auto customScrollbar">
            <cartCard v-for="(plan, index) in plans" :key="index" :plan="plan" />
            <div class="py-2 text-right border-b border-gray-200">
              <h6 class="m-0 text-base font-roboto font-semibold text-[#BA90C6]">Total Amount</h6>
              <h2 class="m-0 text-3xl font-roboto font-bold  text-gray-950">$999.99</h2>
            </div>
            <button
              class="px-3 py-1.5 mt-4 flex justify-center items-center mx-auto gap-1 text-base rounded-full bg-[#FC819E] hover:!shadow-md">
              <span class="text-white">Go to NRG Protects to Enroll</span>
              <img src="../../assets/images/arrow-icon.png" class="w-7 h-7 object-contain" alt="icon">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NRG Modal -->
  <div class="modal fade" id="NRGModal" ref="NRGModal" tabindex="-1" aria-labelledby="NRGModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered !w-[500px] !absolute !right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative rounded-lg overflow-hidden h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
              <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <h4 class="text-xl m-0 font-roboto font-bold text-gray-800">You're Being Redirected to Complete Your
                  Purchase</h4>
              </div>
            </div>
          </div>
          <div class="max-h-[80vh] overflow-y-auto customScrollbar mt-3">
            <p class="text-base font-roboto text-gray-950">Thank you for using FYXIFY! You are now being redirected to
              the
              NRG Protects Inc environment to complete your purchase
              of the protection plan you selected. Please follow the instructions there to finalize your order.</p>
            <p class="text-base font-roboto text-gray-950">If you need assistance at any point, feel free to contact our
              support team. We appreciate your business
              and are here to help!</p>
            <button
              class="px-4 py-1.5 mt-4 flex justify-center items-center mx-auto gap-1 text-base rounded-lg bg-[#00B7C2]">
              <span class="text-white">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import { Slide } from 'vue3-carousel';
import customSlider from '../../components/partialComponent/customSlider.vue';
import protectionPlanCard from "../../components/protectionPlansCards/protectionPlansCard.vue";
import protectionPlanDetailCard from '../../components/protectionPlansCards/protectionPlanDetailCard.vue';
import cartCard from "../../components/cartCard/cartCard.vue";


export default {
  components: {
    protectionPlanCard,
    protectionPlanDetailCard,
    customSlider,
    Slide,
    cartCard,
    // Carousel,
    // CarouselPagination,
    // Pagination,
    // Navigation,
  },
  data() {
    return {
      selectedPlanId: null,
      plans: [
        { id: 1, title: "Plumbing Repair and Maintenance Plan and Water Heater Repair PLUS", price: "$10" },
        { id: 2, title: "Standard Plan", price: "$20" },
        { id: 3, title: "Premium Plan", price: "$30" },
        { id: 4, title: "Elite Plan", price: "$40" },
      ],
    };
  },
  methods: {
    cartModal() {
      this.modal = new Modal(this.$refs.cartModal);
      this.modal.show();
    },
    nrgModal() {
      this.modal = new Modal(this.$refs.NRGModal);
      this.modal.show();
    }
  },
};
</script>
